import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../../SuperAdmin/Controller/Client/UpdateCompanyTermsController";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import HelpSite from "../../../Common/HelpLink";
import Swal from 'sweetalert2';
import BASE_URL from "../../../../config/config";
import TermsConditionService from "../../controller/TermsConditionController/TermsConditionController";
function CreateAgreement() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ DocID: "0", TermConditions: '', CoSetupID: '', FileName: '', Path: '', File: null });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [TermConditionList, setTermConditionList] = useState([]);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const fetchTermsCondition = async () => {
        try {

            const data = await TermsConditionService.GetAllTermsCondition(redirectCallback);
            setTermConditionList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchTermsCondition();
        async function fetchCompanySetup() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/');
                };
                const ClientID = localStorage.getItem('CompanyID');
                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                setFormData({
                    DocID: companySetup[0].DocID,
                    TermConditions: companySetup[0].TermConditions,
                    CoSetupID: companySetup[0].CoSetupID,
                    FileName: companySetup[0].TermFile,
                    Path: companySetup[0].Path,
                });
            } catch (error) {
                console.error('Error fetching company setup:', error);
            }
        }
        fetchCompanySetup();
    }, [navigate]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {

        event.preventDefault();
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        let validationErrors = {};

        if (!formData.File) {
            validationErrors.Path = "Please attach a file before saving.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return; // stop form submission
        }
        formData.DocID = 0;
        const postData = await handleSubmit(formData, setFormData, setErrors, redirectCallback, redirectUserList);
        debugger;
        if (postData.data.message) {
            Swal.fire(
                'Success!',
                'Data saved Successfully.',
                'success'
            );
            const updatedCompanySetup = await CompanySetupController.GetCompanyByID(redirectCallback, formData.CoSetupID);
            setFormData({
                DocID: updatedCompanySetup[0]?.DocID,
                TermConditions: updatedCompanySetup[0]?.TermConditions,
                CoSetupID: updatedCompanySetup[0]?.CoSetupID,
                FileName: updatedCompanySetup[0]?.TermFile, // 👈 important fix
                Path: updatedCompanySetup[0]?.Path,
            });
            window.scrollTo(0, 0);
        }
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFormData(prevState => ({
            ...prevState,
            File: file,
            Path: file ? file.name : ''
        }));
    };
    const handleTermConditionChange = async (ModuleID, value) => {
        try {
            debugger;
            await TermsConditionService.CreateTermCondition(ModuleID, value);
            fetchTermsCondition();
        } catch (error) {
            console.error("Error updating default:", error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12">

                    <HelpSite FormName="Agreement Setting" Module="26" />
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Terms and Conditions</label>
                    <div className="col-sm-3">
                        <input type="hidden" className="form-control" name="CoSetupID" value={formData.CoSetupID} onChange={handleFieldChange} />
                        <input type="file" className="form-control file-control" name="File" onChange={handleFileChange} />
                        {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}
                    </div>
                    <div className="col-sm-2">
                        {formData.TermConditions &&
                            formData.TermConditions !== "" &&
                            formData.TermConditions !== "undefined" && (
                                <a
                                    href={`${BASE_URL}/uploads/${formData.CoSetupID}/Admin/TermConditions/${formData.FileName}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    View Document
                                </a>
                            )
                        }
                    </div>
                    <div className="col-sm-2">
                        <button type="submit" className="btn btn-primary">
                            <i className="icofont-save" aria-hidden="true"> Save

                            </i>
                        </button>
                    </div>
                </div>
            </form>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <table className="table m-0 table-hover">
                    <thead>
                        <tr>
                            <th>Module Name</th>
                            <th>Term & Condition</th>
                            <th style={{ textAlign: "right" }}>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {TermConditionList.map((term) => (
                            <tr key={term.PK_SearchModule_ID}>
                                <td>{term.vc_ModuleName}</td>
                                <td>{term.TermCondition}</td>
                                <td style={{ textAlign: "right" }}>

                                    <select
                                        className="form-control"
                                        value={term.IsTermCondition}
                                        onChange={(e) =>
                                            handleTermConditionChange(term.PK_SearchModule_ID, e.target.value)
                                        }
                                    >
                                        <option value={0}>No</option>
                                        <option value={1}>Yes</option>
                                    </select>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


        </div>
    );
}

export default CreateAgreement;
